import { render, staticRenderFns } from "./CabecalhoOrcamento.vue?vue&type=template&id=31bff30b&scoped=true"
import script from "./CabecalhoOrcamento.vue?vue&type=script&lang=js"
export * from "./CabecalhoOrcamento.vue?vue&type=script&lang=js"
import style0 from "./CabecalhoOrcamento.vue?vue&type=style&index=0&id=31bff30b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31bff30b",
  null
  
)

export default component.exports